import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Divider,
  LinearProgress,
  linearProgressClasses,
  styled,
  TextField,
  InputBase,
} from "@mui/material";

import Nav from "../../Components/Nav";

import Presalebg from "../../assets/Presalebg.png";
import preSaleFrame from "../../assets/preSaleFrame.png";
import bnb from "../../assets/bnb.png";
import bgframe from "../../assets/bgframe.png";

import { ArrowDownward } from "@mui/icons-material";

import { usePrsaleContract, useTokenContract } from "../../Connectivity/Hooks";
import { AppContext } from "../../utils";
import { formatUnits, parseUnits } from "@ethersproject/units";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading";
import moment from "moment";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  margin: "1.3rem 0rem",
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#044474",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

const Presale = () => {
  const { account, connect, disconnect, signer } = useContext(AppContext);
  const preSaleContract = usePrsaleContract(signer);
  const tokenContract = useTokenContract(signer);

  const [amount, setAmount] = useState("");
  const [token, setToken] = useState("");
  const [claimed, setClaimed] = useState(true);

  const [symbol, setSymbol] = useState("");
  const [decimal, setDecimal] = useState("");
  const [supply, setSupply] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalBalance, setTotalBalance] = useState("");
  const [soldToken, setSoldToken] = useState("");

  // console.log(preSaleContract, "preSaleContract");

  // console.log(totalBalance, "total");
  // console.log(soldToken, "total");

  const percent = (soldToken / totalBalance) * 100;

  const intiToken = async () => {
    try {
      const symbol = await tokenContract.symbol();
      const decimals = await tokenContract.decimals();
      const totalSupply = await tokenContract.totalSupply();
      const totaltokenBalance = await preSaleContract.getContractTokenBalance();
      const soldToken = await preSaleContract.soldToken();
      setTotalBalance(formatUnits(totaltokenBalance.toString(), 18));
      setSoldToken(formatUnits(soldToken.toString(), 18));

      // console.log(+totaltokenBalance, +soldToken, totalSupply, "9409-14");

      setSymbol(symbol);
      setDecimal(decimals);
      setSupply(formatUnits(totalSupply.toString(), 18));
      const value = await preSaleContract.bnbToToken(
        parseUnits(amount.toString(), 18)
      );
      setToken(formatUnits(value.toString(), 18));
    } catch (error) {
      console.log(error);
    }
  };

  const init = async () => {
    console.log(claimed, "claimed");
    try {
      const claimed = await preSaleContract.claimed(account);
      setClaimed(claimed);

      console.log(claimed, "claimed");
    } catch (error) {
      console.log(error);
    }
  };

  const buyHadler = async () => {
    if (account) {
      if (!amount) {
        toast.error("Error! Please enter a amount");
      } else if (isNaN(amount) || +amount < 0) {
        toast.error("Error! Please enter a valid amount");
      } else if (+amount === 0) {
        toast.error("Error!  Please enter a valid amount");
      } else {
        try {
          setLoading(true);
          const tx = await preSaleContract.buyToken({
            value: parseUnits(amount, 18),
          });
          await tx.wait();
          toast.success("Success! Transaction confirmed.");
          setLoading(false);
        } catch (error) {
          setLoading(false);
          if (error?.data?.message) {
            toast.error(error?.data?.message);
            console.log(error?.data?.message);
          } else {
            toast.error(error?.message);
            console.log(error?.message);
          }
        }
      }
    } else {
      toast.error("Error! Please connect your wallet.");
    }
  };
  useEffect(() => {
    init();
    console.log("init");
  }, [account, amount]);
  useEffect(() => {
    intiToken();
  }, [amount, amount]);

  // const [timeRemaining, setTimeRemaining] = useState("");

  const [remainingTime, setRemainingTime] = useState(null);

  useEffect(() => {
    const eventDate = moment("2023-5-1 00:00:00"); // set your event date here
    const today = moment();
    const duration = moment.duration(eventDate.diff(today));

    setRemainingTime({
      days: Math.floor(duration.asDays()),
      hours: duration.hours(),
      minutes: duration.minutes(),
      seconds: duration.seconds(),
    });

    const interval = setInterval(() => {
      const today = moment();
      const duration = moment.duration(eventDate.diff(today));

      setRemainingTime({
        days: Math.floor(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const timerData = [
    {
      timeRemaining: remainingTime?.days,
      name: "days",
    },
    {
      timeRemaining: remainingTime?.hours,
      name: "hour",
    },
    {
      timeRemaining: remainingTime?.minutes,
      name: "min",
    },
    {
      timeRemaining: remainingTime?.seconds,
      name: "sec",
    },
  ];

  return (
    <Box
      sx={{
        background: `url(${Presalebg}),#0D3B58`,
        backgroundSize: "100% 100%",
        height: "100%",
        minHeight: "100vh",
        backgroundRepeat: "no-repeat",
        paddingBottom: "4rem",
      }}
    >
      <Container>
        <Nav />
        <Box>
          <Typography
            varaint="h3"
            sx={{
              fontSize: { xs: "25px", md: "36px" },
              fontWeight: "400",
              fontFamily: "Zen Dots",
              color: "white",
              textAlign: "center",
            }}
          >
            PULSAREX PRESALE
          </Typography>
          <Box>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <Box
                  mt={5}
                  sx={{
                    background: `url(${preSaleFrame})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    padding: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  <Loading loading={loading} />
                  <Box
                    sx={{
                      border: "10px solid #3A9EAA",
                      bgcolor: "#044475",
                      height: "240px",
                    }}
                  >
                    <Box padding="1.5rem">
                      <Typography sx={{ color: "white", textAlign: "left" }}>
                        From
                      </Typography>

                      <Box display="flex" justifyContent="space-beteen">
                        <InputBase
                          style={{
                            color: "#ffffff",
                            fontFamily: "Montserrat",
                            fontWeight: "600",
                            fontSize: "18px",
                            width: "100%",
                          }}
                          fullWidth
                          type="text"
                          id="standard-basic"
                          variant="standard"
                          placeholder="0.00"
                          value={amount}
                          onChange={(e) => {
                            setAmount(e.target.value);
                          }}
                        />
                        <Box
                          display="flex"
                          borderRadius="0px"
                          style={{
                            color: "#ffffff",
                            fontFamily: "Regular",
                            fontWeight: "500",
                            fontSize: "16px",
                            marginTop: "10px",
                          }}
                        >
                          <img width="48px" height="40px" src={bnb} alt="" />
                        </Box>
                      </Box>
                    </Box>
                    <Box textAlign="center">
                      <ArrowDownward
                        style={{ color: "#3C9FAA", fontSize: "2.5rem" }}
                      />
                    </Box>
                    <Box padding="0 1.5rem">
                      <Typography sx={{ color: "white", textAlign: "left" }}>
                        T0
                      </Typography>

                      <Box display="flex" justifyContent="space-beteen" mb={2}>
                        <InputBase
                          style={{
                            color: "#ffffff",
                            fontFamily: "Montserrat",
                            fontWeight: "600",
                            fontSize: "18px",
                            width: "100%",
                          }}
                          fullWidth
                          type="text"
                          id="standard-basic"
                          variant="standard"
                          placeholder="0.00"
                          value={token}
                        />
                        <Box
                          display="flex"
                          borderRadius="0px"
                          style={{
                            color: "#ffffff",
                            fontFamily: "Regular",
                            fontWeight: "500",
                            fontSize: "16px",
                            marginTop: "10px",
                          }}
                        >
                          <img width="48px" height="40px" src={bnb} alt="" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    {account ? (
                      <Button
                        sx={{
                          my: 2,
                          px: 4,
                          color: "black",
                          display: "block",
                          fontSize: "1.1rem",
                          borderRadius: "10px",
                          background:
                            "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        }}
                        onClick={() => buyHadler()}
                      >
                        Buy Now
                      </Button>
                    ) : (
                      <Button
                        sx={{
                          my: 2,
                          px: 4,
                          color: "black",
                          display: "block",
                          fontSize: "1.1rem",
                          borderRadius: "10px",
                          background:
                            "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        }}
                        onClick={() => connect()}
                      >
                        Connect Wallet
                      </Button>
                    )}
                  </Box>
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  mt={5}
                  sx={{
                    background: `url(${preSaleFrame})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    padding: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      background: "#103B58",
                      padding: "2rem",
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "16px",
                        fontFamily: "ZenDots",
                        fontWeight: "400",
                        color: "white",
                      }}
                    >
                      Token sale End In!
                    </Typography>
                    <Box display="flex" justifyContent="space-between" mt={2}>
                      {timerData.map(({ timeRemaining, name }, i) => {
                        return (
                          <Box
                            key={i}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="column"
                          >
                            <Box
                              border="1px solid #5BF8FF"
                              width="44.62px"
                              height="60px"
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              color="white"
                              borderRadius="10px"
                            >
                              {timeRemaining}
                            </Box>
                            <Typography color="white" mt={1}>
                              {name}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                    <Divider sx={{ bgcolor: "#6E96AD", margin: "1rem 0rem" }} />
                    <Box>
                      <Box display="flex" justifyContent="space-between">
                        <Typography
                          variant="h6"
                          sx={{ fontSize: "1rem", color: "white" }}
                        >
                          Progress
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{ fontSize: "1rem", color: "white" }}
                        >
                          {percent ? percent?.toFixed(5) : 0}%
                        </Typography>
                      </Box>

                      <BorderLinearProgress
                        variant="determinate"
                        value={percent ? percent : "0"}
                      />
                      <Box display="flex" justifyContent="space-between">
                        <Typography
                          variant="h6"
                          sx={{ fontSize: "1rem", color: "white" }}
                        >
                          0
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{ fontSize: "1rem", color: "white" }}
                        >
                          {soldToken ? soldToken : 0}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    background: `url(${bgframe})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    padding: "2rem",
                    textAlign: "center",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      Token Name
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      PULSE
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      Symbol
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      {symbol}
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      Decimal
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      {decimal}
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      supply
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      {supply}
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    background: `url(${bgframe})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                    padding: "2rem",
                    textAlign: "center",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      Max Contribution
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      10
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      Your Contribution
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      0
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    color="white"
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem !important" }}
                    >
                      Claimable Token
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.2rem !important", fontWeight: "700" }}
                    >
                      0
                    </Typography>
                  </Box>
                  <Divider sx={{ bgcolor: "#6E96AD", margin: "0.7rem 0rem" }} />
                  <Button
                    fullWidth
                    disabled={claimed === false ? true : false}
                    sx={{
                      my: 1,
                      px: 4,
                      color: "black",
                      display: "block",
                      fontSize: "1.1rem",
                      borderRadius: "10px",
                      background:
                        "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                    }}
                  >
                    claim now
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Presale;
